import {
  makeRequired, stringValidator,
} from '../../../../../OUI/Inputs';

export const submitTypeValidator = makeRequired(stringValidator);
